import { APP_INITIALIZER, FactoryProvider } from '@angular/core';

import { initCookieConsent } from './cookie-consent.init';

export const cookieConsentInitializerProvider: FactoryProvider = {
	provide: APP_INITIALIZER,
	useFactory: () => () => initCookieConsent(),
	multi: true,
};
